import { render, staticRenderFns } from "./RewardCampaign.vue?vue&type=template&id=2e8018c0&"
import script from "./RewardCampaign.vue?vue&type=script&lang=js&"
export * from "./RewardCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports